app.views.budgetCalculator = app.views.base.extend({
  childEvents: {
    'change [data-select-disposable-frequency]': 'onChangeDisposableFrequency',
    'click [data-income-expenditure-section]': 'toggleIncomeExpenditureSection',
    'keypress [data-income-expenditure-section]': 'toggleIncomeExpenditureSection'
  },
  attr: {
    arrowToggle: 'data-arrow-icon',
    selectDIFrequency: 'data-select-disposable-frequency',
    DIFrequency: 'data-disposable-frequency',
    DIValue: 'data-disposable-value'
  },
  classes: {
    sectionContent: 'section-content',
    arrowUp: 'fa-chevron-up',
    arrowDown: 'fa-chevron-down'
  },
  settings: {
    pounds: {
      internationalCode: 'en-GB',
      style: 'currency',
      currencyCode: 'GBP'
    },
    slideSpeed: 200
  },
  init: function init() {},
  toggleIncomeExpenditureSection: function toggleIncomeExpenditureSection(e) {
    if (e.key == 'Enter' || e.keyCode == '32' || e.keyCode == undefined) {
      if (e.keyCode == '32') e.preventDefault();
      if ($(e.currentTarget).parent().find('.' + this.classes.sectionContent).is(':visible')) {
        $(e.currentTarget).parent().find('.' + this.classes.sectionContent).slideUp(this.settings.slideSpeed);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').addClass(this.classes.arrowDown);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').removeClass(this.classes.arrowUp);
      } else {
        $(e.currentTarget).parent().find('.' + this.classes.sectionContent).slideDown(this.settings.slideSpeed);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').removeClass(this.classes.arrowDown);
        $(e.currentTarget).find('[' + this.attr.arrowToggle + ']').addClass(this.classes.arrowUp);
      }
    }
  },
  onChangeDisposableFrequency: function onChangeDisposableFrequency() {
    var _this = this;
    var poundFormatting = new Intl.NumberFormat(_this.settings.pounds.internationalCode, {
      style: _this.settings.pounds.style,
      currency: _this.settings.pounds.currencyCode
    });
    var frequency = $('[' + _this.attr.selectDIFrequency + ']').val();
    $('[' + _this.attr.DIFrequency + ']').html(" / " + frequency.replaceAll("_", " ").toLowerCase());
    var yearlyValue = $('[' + _this.attr.DIValue + ']').attr(_this.attr.DIValue) * 12;
    switch (frequency) {
      case "MONTHLY":
        {
          var value = $('[' + _this.attr.DIValue + ']').attr(_this.attr.DIValue) * 1;
          var displayValue = poundFormatting.format(value);
          $('[' + _this.attr.DIValue + ']').html(displayValue);
          break;
        }
      case "WEEKLY":
        {
          var value = _this._calculateDisplayValue(yearlyValue, 52);
          var displayValue = poundFormatting.format(value);
          $('[' + _this.attr.DIValue + ']').html(displayValue);
          break;
        }
      case "EVERY_2_WEEKS":
        {
          var value = _this._calculateDisplayValue(yearlyValue, 26);
          var displayValue = poundFormatting.format(value);
          $('[' + _this.attr.DIValue + ']').html(displayValue);
          break;
        }
      case "EVERY_4_WEEKS":
        {
          var value = _this._calculateDisplayValue(yearlyValue, 13);
          var displayValue = poundFormatting.format(value);
          $('[' + _this.attr.DIValue + ']').html(displayValue);
          break;
        }
      default:
        {
          var value = $('[' + _this.attr.DIValue + ']').attr(_this.attr.DIValue) * 1;
          var displayValue = poundFormatting.format(value);
          $('[' + _this.attr.DIValue + ']').html(displayValue);
          break;
        }
    }
  },
  _calculateDisplayValue: function _calculateDisplayValue(yearlyValue, dividerValue) {
    var displayValue = Math.floor(yearlyValue * 100 / dividerValue) / 100;
    return displayValue;
  }
});